import { memo } from "react"
import CookieConsent from "react-cookie-consent"
import { Link } from "react-router-dom"

import { useTheme } from "@mui/material"

const Cookies = () => {
  const {
    palette: {
      primary: { main },
      text: { primary, cancel },
      background: { card },
    },
  } = useTheme()
  return (
    <CookieConsent
      location="bottom"
      buttonText="I understand"
      cookieName="_sckey"
      style={{
        background: card,
        color: primary,
        padding: "2em 2em 3em",
        zIndex: 80000,
        animation: "slide-up 3s ease 300ms backwards",
      }}
      buttonStyle={{
        backgroundColor: "transparent",
        border: `1px solid ${main}`,
        padding: "0.75em 2em",
        color: main,
        fontSize: "1.4rem",
      }}
      buttonClasses="cookies-btn"
      expires={365}
      overlay={true}
      overlayStyle={{
        background: "hsl(30% 70% 10% / 0.6)",
        backdropFilter: "blur(5px)",
        zIndex: 81000,
      }}
    >
      <span style={{ color: main, fontWeight: 900 }}>
        <span
          style={{
            fontFamily: "Goldman, cursive",
            fontWeight: 900,
            fontSize: "1.8rem",
            color: primary,
          }}
        >
          Snippify
        </span>{" "}
        - uses tracking cookies to understand how you use the app and
        help us improve it.
      </span>
      <br />
      <span style={{ color: cancel, fontSize: "1.2rem" }}>
        It&apos;s completely anonymously tracking, without any kind of
        collecting personal data/code blocks.
      </span>{" "}
      <br />
      <Link style={{ color: main }} to="/info">
        Read more
      </Link>
    </CookieConsent>
  )
}
export default memo(Cookies)
